// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3hIaB","large":"styles_large__gBVLo"};